module.exports = __webpack_public_path__ + "040feebb3277ecd8ccb3bdef07576cdc.svg";